import { Token } from "./types";

export const tokensToBuy: Token[] = [
    {
        id: 0,
        count: 1,
        price: 1800,
    },
    {
        id: 1,
        count: 5,
        price: 9000,
        discount: 10,
    },
    {
        id: 2,
        count: 10,
        price: 18000,
        discount: 25,
    },
];
